<script setup lang="ts">
// per https://nuxt.com/docs/guide/directory-structure/error
import type { NuxtError } from '#app';

const props = defineProps({
    // eslint-disable-next-line vue/require-default-prop
    error: Object as () => NuxtError,
});

const isDev = process.env.NODE_ENV === 'development';
const title = computed(() => (props.error?.statusCode === 404 ? "This page doesn't exist" : 'Something went wrong'));

useHead({ title });
</script>

<template>
    <nuxt-layout
        name="default"
        class="error-layout">
        <es-row>
            <es-col
                md="7"
                class="my-500 mx-auto text-center">
                <h1 class="post1 text-gray-600">{{ title }}</h1>
                <p
                    id="msgError"
                    class="font-size-lg text-gray-600">
                    {{ error?.statusCode }} · {{ error?.message }}
                </p>
                <pre
                    v-if="isDev && error?.statusCode === 500 && error.stack"
                    class="text-left small"
                    >{{ error.stack }}</pre>
                <es-button to="/">Go to New Design</es-button>
            </es-col>
        </es-row>
    </nuxt-layout>
</template>

<style lang="scss">
@use '@energysage/es-ds-styles/scss/variables';

// target so that this override only applies for error layout (as in quote-edit)
.error-layout {
    .body-container {
        .content-container {
            background-color: variables.$gray-50 !important;
        }
    }
}
</style>
